import React from "react";
import {useTranslation} from "react-i18next";
import {Spinner} from "react-bootstrap";
import GenericTable from "./GenericTable";
import Pagination from "@material-ui/lab/Pagination";
import {scanInOutMetadata} from "./data/scanInOutMetadata";
import {ScanDateFilter} from "./ScanDateFilter";

export const LeftOverStats = React.memo( ({
                                          dateFilters ,
                                          setDateFilters ,
                                          loading,
                                          data,
                                          handleChangePage
}) => {
    const {t} = useTranslation();

    return (
        <>
            {
                loading &&
                (
                    <div className="spinner-global-content">
                        <Spinner variant="success" animation="border" />
                    </div>
                )
            }
            {!loading && (
                <>
                    {data && (
                        <div className="row">
                            <div className="col-12 col-md-4">
                              <p>{t('hub.leftover.stats.daily')} : {  data?.stats?.count_today }</p>
                            </div>
                            <div className="col-12 col-md-4">
                              <p>{t('hub.leftover.stats.weekly')} : {  data?.stats?.count_this_week }</p>
                            </div>
                            <div className="col-12 col-md-4">
                              <p>{t('hub.leftover.stats.monthly')} : {  data?.stats?.count_this_month }</p>
                            </div>
                        </div>                        
                    )}
                </>
                )
            }
        </>
    )
});